import { getCardCommentRestUrl } from '../../../../constants';
import { IGetState, TCardId } from '../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../types/actions';
import { fetchHandler } from '../../../../../util/fetchHandler';
import { Util } from '../../../../../util/util';
import { getRestHeadersPost } from '../../../../helpers/getRestHeadersHelper';
import { IComment } from '../../../../../store/model/card/types/IComment';
import { chatCommentsAdd } from '../../../chats/chat/chatCommentsAdd';
import { isShowChat } from '../../../../../store/model/authUser/selectors/isShowChat';

export const postRest = (
    comment: IComment,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState,
    ): Promise<IComment> => {
        const cardId: TCardId = comment.cardId;
        return fetchHandler<IComment>(
            Util.getApiUrl(getCardCommentRestUrl(cardId)), {
                ...getRestHeadersPost(),
                body: JSON.stringify(comment)
            }
        ).then((comment)=>{
            dispatch(chatCommentsAdd(comment));
            return comment;
        });
    };
    return action;
};
